import { render } from "./video-v1.vue?vue&type=template&id=2418ccb4&scoped=true"
import script from "./video-v1.vue?vue&type=script&lang=js"
export * from "./video-v1.vue?vue&type=script&lang=js"

import "./video-v1.vue?vue&type=style&index=0&id=2418ccb4&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2418ccb4"]])

export default __exports__